import { ITutorial, ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-centro-de-custo",

    filtroDeEmpresa: "campo-empresa-filtros-centro-de-custo",
    filtroDeDescricao: "campo-descricao-filtros-centro-de-custo",
    filtroDeTipo: "campo-tipo-filtros-centro-de-custo",
    filtroDeAtivo: "campo-ativo-filtros-centro-de-custo",

    botaoListar: "botao-listar-centros-de-custo",
    botaoAdicionar: "botao-adicionar-centro-de-custo",
}

export const Classes = {
    botaoEditar: "botao-editar-centro-de-custo",
    botaoDesativar: "botao-desativar-centro-de-custo",
}

export const ConsultarCentro: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)!},
        {...MensagensPadrao.filtros.empresa, target: () => document.getElementById(IDs.filtroDeEmpresa)!},
        {...MensagensPadrao.filtros.descricao, target: () => document.getElementById(IDs.filtroDeDescricao)!},
        {...MensagensPadrao.filtros.tipo, target: () => document.getElementById(IDs.filtroDeTipo)!},
        {...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)!},
        {...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)!},
    ]
}

export const AdicionarCentro: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)!},
    ]
}

export const EditarCentro: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)!},
    ]
}

export const DesativarCentro: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)!},
    ]
}

// const tutorialMenuItems: ITutorial[] = [
//     {
//         titulo: "Como consultar centros de custos",
//         tutorial: tutorialConsultarCentro
//     },
//     {
//         titulo: "Como cadastrar um novo centro de custos",
//         tutorial: tutorialAdicionarCentro
//     },
//     {
//         titulo: "Como editar um centro de custos",
//         tutorial: tutorialEditarCentro
//     },
//     {
//         titulo: "Como desativar um centro de custos",
//         tutorial: tutorialDesativarCentro
//     }
// ]